export default __webpack_public_path__ + "static/media/sentinel2-cloudless.34ad912c.png";